import React from "react";
import TaskManagement from "@/pages/onlineOperations/taskManagement/taskManagement";
import CrcExceptionList from "@/pages/onlineOperations/crcExceptionList/crcExceptionList";
import OrderInfoPage from "@/pages/configurationManagement/stub/orderInfoPage";
// 1.3.0新增部分
import ModuleList from "@/pages/configurationManagement/module/moduleList";
import EventMonitoring from "@/pages/exceptionManagement/eventMonitoring/eventMonitoring";
import FaultReportingList from "@/pages/exceptionManagement/faultReporting/faultReportingList";
import ModuleDetail from "@/pages/configurationManagement/module/moduleDetail";
import ModuleInfo from "@/pages/configurationManagement/module/moduleInfo";
// 1.4.0 新增部分
import IndicatorDateDownload from "@/pages/onlineOperations/IndicatorDataDownload/indicatorDateDownload";
import ElectricalLoss from "@/pages/indicatorReport/electricalLoss/electricalLoss";
import StubStationIntact from "@/pages/indicatorReport/stubIntactRate/stubStationIntact";
import ChargeCourse from "@/pages/configurationManagement/stub/orderStubCourse";
import PowerCourse from "@/pages/configurationManagement/stub/orderPowerCourse";
import ChargeOrderDetail from "@/pages/indicatorReport/chargeSuccessRate/chargeOrderDetail";
import StubIntactDetail from "@/pages/indicatorReport/stubIntactRate/stuIntactDetail";
// 1.4.1 新增部分
import MonitoringDetail from "@/pages/exceptionManagement/eventMonitoring/monitoringDetail";
// 1.5.1 新增部分
import OprationLog from "@/pages/oprationLog/oprationLog";
import DisplayBoardIndex from "@/pages/displayBoard/displayBoardIndex";
import StateUnusualList from "@/pages/onlineOperations/stateUnusual/stateUnusualList";
// 1.6.0新增部分
import ErrorCodeManage from "@/pages/system/errorCodeManage";
import ErrorCodeConfig from "@/pages/system/errorCodeManage/errorCodeConfig";
import EquChargeDetail from "@/pages/indicatorReport/chargeSuccessRate/equChargeDetail";
import StationChargeDetail from "@/pages/indicatorReport/chargeSuccessRate/stationChargeDetail";
import DiagnosticAnalysis from "@/pages/diagnosticManage/diagnosticAnalysis/index";
// 1.6.1新增部分
import FirmwareVersion from "@/pages/system/firmwareVersionManage/index";
import FirmwareVersionList from "@/pages/system/firmwareVersionManage/detailList";
// 1.6.2新增部分
import StubBasicInfo from "@/pages/configurationManagement/stub/stubBasicInfo";
import TaskBuildStep from "@/pages/onlineOperations/taskManagement/taskBuildStep";
// 1.7.0 新增部分
import StubGroupTobu from "@/pages/configurationManagement/stubGroup/stubGroupTobu";
import OrderChargeCourse from "../pages/configurationManagement/stub/orderChargeCourse";
import PermissionList from "../pages/system/permissions/permissionList";
import RoleList from "../pages/system/role/roleList";
import WareSourceStubList from "../pages/configurationManagement/stub/waresourceStubList";
import StubList from "../pages/configurationManagement/stub/stubList";
import StubGroupList from "../pages/configurationManagement/stubGroup/stubGroupList";
import PowerBoxList from "../pages/configurationManagement/powerBox/powerBoxList";
import ChargSuccess from "../pages/indicatorReport/chargeSuccessRate/chargeSuccess";
import StubIntact from "../pages/indicatorReport/stubIntactRate/stubIntact";
import Account from "../pages/system/account/account";
import { cookieManager } from "../utils/cookieStorage";
import { sessionManager } from "../utils/sessionStorage";

class Tabs {
  constructor(addTab, remove) {
    return this.init(addTab, remove);
  }

  /**
   * 菜单初始化，根据id指定菜单
   * @param addTab
   * @returns {{}}
   */
  init(addTab, remove) {
    // 微前端子应用基础数据配置
    const microApps = [
      {
        name: "omc",
        // entry: "//localhost:3920/",
        // entry: 'http://localhost:8000',
        entry: process.env.REACT_APP_SAAS_OMC,
        container: "#microapp_omc",
        extraCls: "no-padding no-background",
      },
    ];

    /**
     * 根据appName添加对应参数
     * @param {*} appName 子应用app信息
     * @param {*} initKey 子应用初始化key(可选)
     */
    function bindAppParams(appName, initKey) {
      // 将国际化,用户信息传递到子应用
      const lang = sessionManager.getLasting("locale");
      const authJWT =
        cookieManager.get(`jwtToken_${sessionStorage.getItem("userName")}`) ||
        localStorage.getItem(`jwtToken_${sessionStorage.getItem("userName")}`);
      const userInfo = {
        token: sessionStorage.getItem("token"),
        name: sessionStorage.getItem("name"),
        id: sessionStorage.getItem("userId"),
      };
      return {
        ...(microApps.find((app) => appName === app.name) || {}),
        initKey,
        mainAppName: "omc",
        mainAppInfo: {
          lang,
          authJWT,
          userInfo,
        },
      };
    }

    const Frame = {
      "0001": <DisplayBoardIndex onAdd={addTab} />, // 运行看板
      "0101": <StubGroupList onAdd={addTab} />, // 电站列表
      "0102": <StubList onAdd={addTab} />, // 设备快速查询
      "0103": <WareSourceStubList onAdd={addTab} />, // 仓库设备查询
      "0104": <PowerBoxList onAdd={addTab} />, // 配电柜管理
      "0105": <ModuleList onAdd={addTab} />, // 模块管理
      "0501": <OrderInfoPage onAdd={addTab} />, // 订单列表
      "0502": <OprationLog onAdd={addTab} />, // 桩连平台日志
      "0503": <TaskManagement onAdd={addTab} />, // 任务管理
      "0504": <CrcExceptionList onAdd={addTab} />, // crc异常列表
      "0505": <IndicatorDateDownload onAdd={addTab} />, // 指标数据下载
      "030101": <StubIntact onAdd={addTab} />, // 设备完好率
      "030102": <ChargSuccess onAdd={addTab} />, // 充电成功率
      "030103": <ElectricalLoss onAdd={addTab} />, // 电损
      "0401": <FaultReportingList onAdd={addTab} />, // 故障上报列表
      "0402": <EventMonitoring onAdd={addTab} />, // 平台事件监控列表
      "0403": <StateUnusualList onAdd={addTab} />, // 状态异常列表
      9001: <Account onAdd={addTab} />, // 账户管理
      900301: <PermissionList onAdd={addTab} />, // 权限管理
      900302: <RoleList onAdd={addTab} />, // 角色管理
      9004: <ErrorCodeManage onAdd={addTab} />, // 状态码管理
      9005: <FirmwareVersion onAdd={addTab} />, // 固件版本管理
      "0701": <DiagnosticAnalysis onAdd={addTab} />,
      errorCodeConfig: <ErrorCodeConfig onAdd={addTab} onDelete={remove} />, // 状态码配置
      firmwareVersionList: <FirmwareVersionList onAdd={addTab} />,
      // '10':<OrderChargeCourse onAdd={addTab}/>,
      orderChargeCourse: <OrderChargeCourse onAdd={addTab} />, // 模块数据
      stubDetail: <StubList onAdd={addTab} />, // 设备详情
      moduleDetail: <ModuleDetail onAdd={addTab} />, // 模块详情
      moduleInfo: <ModuleInfo onAdd={addTab} />, // 模块信息
      orderInfoPage: <OrderInfoPage onAdd={addTab} />, // 订单列表
      // 订单-充电过程、模块数据
      chargeCourse: <ChargeCourse onAdd={addTab} />, // 充电数据
      powerCourse: <PowerCourse onAdd={addTab} />, // 模块数据
      // 完好率
      stubStationIntact: <StubStationIntact onAdd={addTab} />, // 电站完好率详情
      stubIntactDetail: <StubIntactDetail onAdd={addTab} />, // 设备完好率详情
      chargeOrderDetail: <ChargeOrderDetail onAdd={addTab} />, // 成功率订单详情
      monitoringDetail: <MonitoringDetail onAdd={addTab} />, // 事件监控详情
      equChargeSuccessDetail: <EquChargeDetail onAdd={addTab} />, // 设备充电成功率
      stationChargeSuccessDetail: <StationChargeDetail onAdd={addTab} />, // 电站充电成功率
      // 1.6.2
      stubBasicInfo: <StubBasicInfo onAdd={addTab} />, // 设备基础信息
      taskBuildStep: <TaskBuildStep onAdd={addTab} />, // 创建任务
      // 1.70
      stubGroupTobu: <StubGroupTobu onAdd={addTab} />,
      // 1.8.0
      18001: {
        isMicroApp: true, // 是否为子应用
        ...bindAppParams("omc", "9527001"), // 子应用名称和要进入的子应用的页面id
      }, // 电站列表
      // 工单列表
      "0506": {
        isMicroApp: true,
        ...bindAppParams("omc", "0506"),
      },
      "0506create": {
        isMicroApp: true,
        ...bindAppParams("omc", "0506create"),
      },
      "0506read": {
        isMicroApp: true,
        ...bindAppParams("omc", "0506read"),
      },
      // 仓库列表
      "050701": {
        isMicroApp: true,
        ...bindAppParams("omc", "050701"),
      },
      "050702": {
        isMicroApp: true, // 是否为子应用
        ...bindAppParams("omc", "050702"), // 子应用名称和要进入的子应用的页面id
      }, // 电站列表
      "050703": {
        isMicroApp: true, // 是否为子应用
        ...bindAppParams("omc", "050703"), // 子应用名称和要进入的子应用的页面id
      }, // 电站列表
      "050704": {
        isMicroApp: true, // 是否为子应用
        ...bindAppParams("omc", "050704"), // 子应用名称和要进入的子应用的页面id
      }, // 调拨单
      // 新增物料审批调拨
      "0507create": {
        isMicroApp: true,
        ...bindAppParams("omc", "0507create"),
      },
      // 物料审批调拨编辑
      "0507editSingle": {
        isMicroApp: true,
        ...bindAppParams("omc", "0507editSingle"),
      },
      // 物料审批调拨详情
      "0507detail": {
        isMicroApp: true,
        ...bindAppParams("omc", "0507detail"),
      },
      // 新增设备
      "900602create": {
        isMicroApp: true,
        ...bindAppParams("omc", "900602create"),
      },
      // 编辑设备
      "900602edit": {
        isMicroApp: true,
        ...bindAppParams("omc", "900602edit"),
      },
      // 设备列表
      900602: {
        isMicroApp: true,
        ...bindAppParams("omc", "900602"),
      },
      // 查看设备
      "900602read": {
        isMicroApp: true,
        ...bindAppParams("omc", "900602read"),
      },
      // Bom清单
      "90bomList": {
        isMicroApp: true,
        ...bindAppParams("omc", "90bomList"),
      },
      // 设备列表
      "0006200100": {
        isMicroApp: true,
        ...bindAppParams("omc", "0006200100"),
      },
      // 配置修改
      "10stubParamsConfig": {
        isMicroApp: true,
        ...bindAppParams("omc", "10stubParamsConfig"),
      },
      // 变更记录
      "10modifyLog": {
        isMicroApp: true,
        ...bindAppParams("omc", "10modifyLog"),
      },
      // 诊断报告
      "10zdbg": {
        isMicroApp: true,
        ...bindAppParams("omc", "10zdbg"),
      },
      // 工单评价配置
      900703: {
        isMicroApp: true,
        ...bindAppParams("omc", "900703"),
      },
      // 设备操作日志 0006200300
      "0006200400": {
        isMicroApp: true,
        ...bindAppParams("omc", "0006200400"),
      },
      // 批量任务管理
      "0006200300": {
        isMicroApp: true,
        ...bindAppParams("omc", "0006200300"),
      },
      // 新建批量配置修改任务
      "0006200301": {
        isMicroApp: true,
        ...bindAppParams("omc", "0006200301"),
      },
      // 新建批量固件升级任务
      "0006200302": {
        isMicroApp: true,
        ...bindAppParams("omc", "0006200302"),
      },
      // omc本地设备操作日志 0508
      "0508": {
        isMicroApp: true,
        ...bindAppParams("omc", "0508"),
      },
    };
    return Frame;
  }
}

export default Tabs;



// WEBPACK FOOTER //
// ./src/AntD/tabs/tabs.js